module.exports = __webpack_public_path__ + "static/media/img_15.ee1aef67.png";